var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalLiteratureAndNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452 150V92.207l-12.633-2.019c-5.499-.879-120.716-18.39-177.813 40.889-17.632-46.945-46.168-71.511-68.862-84.175C162.752 30.192 136.119 30 135 30h-15v57.191c-26.796-.228-46.398 2.842-47.367 2.997L60 92.207V150H0v332h512V150zM90 360.395c28.779-2.499 99.515-4.392 136.847 31.605H90zm332-242v211.861c-14.826-1.188-37.601-1.99-62.316.88-37.112 4.311-67.045 15.675-88.684 33.392v-195.93c29.598-55.159 117.968-53.074 151-50.203zm0 242V392H285.152c37.333-35.997 108.069-34.104 136.848-31.605zM150 62.101c24.773 5.685 72.911 26.739 91 104.625v166.602c-15.384-22.196-33.15-35.967-48.308-44.426-16.461-9.187-31.921-13.381-42.692-15.295zm-30 55.098L119.915 302h15c2.51.029 47.312 1.233 79.785 46.009-17.633-8.413-38.524-14.101-62.383-16.872-24.715-2.871-47.49-2.068-62.316-.88v-211.88c7.557-.664 18.02-1.283 29.999-1.178zM30 180h30v242h181v30H30zm452 272H271v-30h181V180h30z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalLiteratureAndNews);
export default __webpack_public_path__ + "static/media/local-literature-and-news.466247989b438455a8e8a630d77b7da9.svg";
export { ForwardRef as ReactComponent };